export const ActionTypes = {
  LOADING: "LIST_DOMAINS_LOADING",
  ERROR: "LIST_DOMAINS_ERROR",
  SUCCESS: "LIST_DOMAINS_SUCCESS",
};
